import lineSeriesBuilder from "./charts/lineSeriesBuilder.js";
import optionsBuilder from "./charts/optionsBuilder.js";
import scatterSeriesBuilder from "./charts/scatterSeriesBuilder.js";
import seriesBuilder from "./charts/seriesBuilder.js";
import seriesPlotOptionsBuilder from "./charts/seriesPlotOptionsBuilder.js";
import xDateAxisBuilder from "./charts/xDateAxisBuilder.js";
import yAxisBuilder from "./charts/yAxisBuilder.js";

const charts = optionsBuilder;
charts.seriesPlotOptions = seriesPlotOptionsBuilder;
charts.yAxis = yAxisBuilder;
charts.xDateAxis = xDateAxisBuilder;
charts.series = seriesBuilder;
charts.lineSeries = lineSeriesBuilder;
charts.scatterSeries = scatterSeriesBuilder;

export default charts;
